const content = `<b>– csrftoken:</b> Verhindert Cross-Site Request Forgery-Angriffe.
<b>– sessionid:</b> Dient dem Verfolgen einer Benutzersitzung.
<b>– device_token:</b> Dient der Reduzierung von 2FA-Anmeldungen.

Hinweis: Der <b>Google-Tag-Manager</b> wird auf dieser Seite verwendet. Er selbst setzt keine eigenen Cookies, da er nur als Container für andere Tags dient.` 

function EssentialCookieInfoDe(props) {
    return (
        <div className="text_2" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: content}}/>
    );
}

export default EssentialCookieInfoDe;
